import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Package } from '../../interface/package';

@Injectable()
export class PackageService {

  constructor(private httpClient: HttpClient) { }

  list(filter = ""): Observable<Package[]> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<Package[]>('package' + filter);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/package/package.service.ts